import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Bankki Media',
  description = 'Bankki Media is a full-service creative agency specializing in branding, video production, digital marketing, and web design. We craft culture, not just content.',
  keywords = 'creative agency, branding, video production, digital marketing, web design, content creation',
  image = '/og-image.jpg',
  url = '',
  type = 'website',
}) => {
  const siteUrl = 'https://bankkimedia.com';
  const fullUrl = `${siteUrl}${url}`;
  const fullTitle = title === 'Bankki Media' ? title : `${title} | Bankki Media`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Bankki Media" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${siteUrl}${image}`} />
      <meta property="og:site_name" content="Bankki Media" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={`${siteUrl}${image}`} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <link rel="canonical" href={fullUrl} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Bankki Media",
          "url": siteUrl,
          "logo": `${siteUrl}/logo.png`,
          "description": description,
          "sameAs": [
            "https://instagram.com/bankkimedia",
            "https://twitter.com/bankkimedia",
            "https://linkedin.com/company/bankkimedia"
          ],
          "contactPoint": {
            "@type": "ContactPoint",
            "email": "contact@bankkimedia.com",
            "contactType": "customer service"
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
